import propTypes from 'prop-types';
import * as S from './styles';

const RangeSlider = ({ length, orientation, ...props }) => (
  <S.Wrapper $length={length} $orientation={orientation}>
    <S.Input
      {...props}
      type="range"
      $length={length}
      $orientation={orientation}
    />
  </S.Wrapper>
);

RangeSlider.propTypes = {
  length: propTypes.number,
  orientation: propTypes.oneOf(['horizontal', 'vertical']),
};

RangeSlider.defaultProps = {
  length: 120,
  orientation: 'horizontal',
};

export default RangeSlider;
